/**
 * Ticket Workspace Types
 *
 * Types for workspace configuration, workflow stages, and automation rules
 * in the workspace-based ticket system.
 */
// --- Entity name constants ---
export const TICKET_WORKSPACE = 'TicketWorkspace';
export const TICKET_WORKFLOW_STAGE = 'TicketWorkflowStage';
export const TICKET_AUTOMATION_RULE = 'TicketAutomationRule';
export const TICKET_AUTOMATION_EXECUTION = 'TicketAutomationExecution';
// --- Permission Capabilities ---
export const TicketPermissionCapability = {
    CREATE_TICKET: 'CREATE_TICKET',
    VIEW_OWN_TICKETS: 'VIEW_OWN_TICKETS',
    VIEW_WORKSPACE_TICKETS: 'VIEW_WORKSPACE_TICKETS',
    COMMENT: 'COMMENT',
    ADD_INTERNAL_NOTE: 'ADD_INTERNAL_NOTE',
    ATTACH_FILES: 'ATTACH_FILES',
    EDIT_TICKET_FIELDS: 'EDIT_TICKET_FIELDS',
    CHANGE_ASSIGNEE: 'CHANGE_ASSIGNEE',
    MOVE_TICKET: 'MOVE_TICKET',
    CLOSE_TICKET: 'CLOSE_TICKET',
    CANCEL_TICKET: 'CANCEL_TICKET',
    CONFIGURE_WORKSPACE: 'CONFIGURE_WORKSPACE',
    CONFIGURE_STAGE: 'CONFIGURE_STAGE',
    CONFIGURE_AUTOMATION: 'CONFIGURE_AUTOMATION',
    EXECUTE_APPROVAL: 'EXECUTE_APPROVAL',
};
// --- Automation Trigger Events ---
export const TicketAutomationTriggerEvent = {
    TICKET_CREATED: 'ticket.created',
    TICKET_CLOSED: 'ticket.closed',
    TICKET_CANCELLED: 'ticket.cancelled',
    TICKET_MESSAGE_CREATED: 'ticket.message.created',
    TICKET_STAGE_ENTERED: 'ticket.stage.entered',
    TICKET_STAGE_EXITED: 'ticket.stage.exited',
    TICKET_ASSIGNEE_CHANGED: 'ticket.assignee.changed',
    TICKET_APPROVAL_REQUESTED: 'ticket.approval.requested',
    TICKET_APPROVAL_COMPLETED: 'ticket.approval.completed',
    TICKET_ATTACHMENT_ADDED: 'ticket.attachment.added',
};
/** All valid trigger event strings (for server-side whitelist validation). */
export const TICKET_AUTOMATION_TRIGGER_EVENTS = Object.values(TicketAutomationTriggerEvent);
// --- Automation Action Types ---
export const TicketAutomationActionType = {
    UPDATE_TICKET_FIELDS: 'UPDATE_TICKET_FIELDS',
    ADD_MESSAGE: 'ADD_MESSAGE',
    CHANGE_STAGE: 'CHANGE_STAGE',
    CHANGE_LIFECYCLE_STATUS: 'CHANGE_LIFECYCLE_STATUS',
    ASSIGN_USER: 'ASSIGN_USER',
    CALL_INTEGRATION: 'CALL_INTEGRATION',
    NOTIFY: 'NOTIFY',
};
// --- Automation Execution Mode ---
export const TicketAutomationExecutionMode = {
    SEQUENTIAL: 'sequential',
    PARALLEL: 'parallel',
};
// --- Automation Execution ---
export const TicketAutomationExecutionStatus = {
    SUCCESS: 'success',
    ERROR: 'error',
    TIMEOUT: 'timeout',
    SKIPPED: 'skipped',
};
//# sourceMappingURL=ticket-workspace.js.map